import React from "react";
//
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
//
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";
//
import {
  ProgramContainer,
  HeadingContainer,
  CardContainer,
  Card,
  IconContainer,
  TextContainer,
  StyledButton,
  Container,
} from "./style";
//
import data from "./data";
//
function PartnerProgram({ registrationFormRef, buttonText }) {
  const handleScrollToRegistrationForm = () => {
    let cardDiv = registrationFormRef.current;
    cardDiv.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Container>
      <ProgramContainer>
        <HeadingContainer>
          <Typography
            variant="display4"
            fontSize={["20px", "20px", "36px"]}
            lineHeight={["24px", "24px", "36px"]}
            color={theme.colorsV2.purple.shade_900}
          >
            Our customizable corporate programs include
          </Typography>
        </HeadingContainer>
        <CardContainer>
          {data.map((item) => {
            const { title, content, icon } = item;
            return (
              <Card key={title}>
                <IconContainer>
                  <StyledSvgSprite icon={icon} height="40px" width="40px" />
                </IconContainer>
                <TextContainer>
                  <Typography
                    variant="heading3"
                    fontSize={["18px", "18px", "24px"]}
                    lineHeight={["24px", "24px", "32px"]}
                    color={theme.colorsV2.primary.shade_800}
                    mt={["0px", "0px", "16px"]}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant="display4"
                    fontSize={["12px", "12px", "16px"]}
                    lineHeight={["16px", "16px", "24px"]}
                    color={theme.colorsV2.gray.shade_600}
                    mt="8px"
                  >
                    {content}
                  </Typography>
                </TextContainer>
              </Card>
            );
          })}
        </CardContainer>
        <StyledButton onClick={handleScrollToRegistrationForm}>
          <Typography
            variant="heading3"
            fontSize={["18px", "18px", "32px"]}
            lineHeight={["24px", "24px", "40px"]}
            color={theme.colorsV2.primary.shade_50}
          >
            {buttonText || "Packages start at just INR 340 per employee! ↗️"}
          </Typography>
        </StyledButton>
      </ProgramContainer>
    </Container>
  );
}

export default PartnerProgram;
